import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import fr from './fr.json' with { type: 'json' };

const stored = (() => {
  try {
    return localStorage.getItem('crm.lang');
  } catch {
    return null;
  }
})();

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: stored ?? 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

export function setLanguage(lang: 'fr' | 'en'): void {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem('crm.lang', lang);
  } catch {
    /* stockage indisponible : la langue vaut pour la session */
  }
}

export default i18n;
